import type { NavigationMenu, NavigationMenuProps } from '../../../components/navigationbar/type/propsTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformNavigationMenu = (data: CMSTransformerDataType): NavigationMenuProps => {
  const HeaderCategories = data.level_1_menus?.map((level1: CMSTransformerDataType) => {
    const Categories: CMSTransformerDataType[] = [];
    level1?.level_2_menus?.map((level2: CMSTransformerDataType) => {
      const imageUrl = level2?.image.images?.[0]?.image?.url;
      const altText = level2?.image.images?.[0]?.alt_text;
      const imageList = level2?.image.images?.map((image: CMSTransformerDataType) => ({
        url: image?.image.url,
        altText: image?.alt_text,
        viewport: image?.viewport,
      }));
      Categories.push({
        title: level2?.title,
        imageUrl: imageUrl,
        imageList: imageList,
        overlayGradient: level2.gradient_type,
        linearGradient: level2.linear_gradient?.color,
        link: level2?.link,
        altText: altText,
        subCategories:
          level2 &&
          level2?.level_3_menus?.map((level3: CMSTransformerDataType) => ({
            title: level3.title,
            url: level3.link.url,
            target: level3.link.target,
            queryParams: level3.link.query_params,
          })),
      });
    });
    return Categories;
  });
  const navigations: NavigationMenu[] = data.level_1_menus?.map((menu: CMSTransformerDataType, index: number) => ({
    allTitle: menu.all_title,
    title: menu.title,
    menuType: menu.menu_type,
    menuId: menu.menu_id,
    categories: HeaderCategories[index],
    url: menu.link.url,
    viewport: menu.viewport,
  }));
  return {
    navigations,
    componentType: 'mega_menu',
    activeRoute: data.activeRoute,
  };
};

export default transformNavigationMenu;
